import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const TypographyDisclaimer = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-typography-disclaimer', 'border border-solid border-[#ECE9F8] bg-[#F6F6FA] p-3 text-primary-dark [&_a]:font-bold', className)}
    {...props}
  />
));
TypographyDisclaimer.displayName = 'TypographyDisclaimer';

export { TypographyDisclaimer };
